export default __webpack_public_path__ + "static/media/subscriptions.38c8dcac.svg";